// ---------------------------------------------------------------------------
// PWA Caisse Tablette — Ticket list (scrollable, with loading/empty states)
// ---------------------------------------------------------------------------

import TicketCard from '@/components/TicketCard';
import type { TicketData } from '@/components/TicketCard';

interface TicketListProps {
  tickets: TicketData[];
  isLoading: boolean;
  onSelect: (ticket: TicketData) => void;
}

export default function TicketList({ tickets, isLoading, onSelect }: TicketListProps) {
  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-gray-400">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="animate-spin mb-3">
          <path d="M21 12a9 9 0 1 1-6.219-8.56" />
        </svg>
        <p className="text-sm">Chargement des tickets...</p>
      </div>
    );
  }

  if (tickets.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-gray-400">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="mb-3 opacity-50">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
        <p className="text-sm">Aucun ticket trouve</p>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto pb-4">
      {tickets.map((ticket, idx) => (
        <TicketCard
          key={ticket.id ?? ticket.transaction_id ?? idx}
          ticket={ticket}
          onClick={() => onSelect(ticket)}
        />
      ))}
    </div>
  );
}
